import React, { useEffect, useState } from "react";
import { getCurrentUser } from "aws-amplify/auth";
import { Navigate, useLocation } from "react-router-dom";

interface ProtectRouteProps {
  Component: React.ComponentType;
}

const ProtectRoute: React.FC<ProtectRouteProps> = ({ Component }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await getCurrentUser();
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return null; // or return a loading spinner if you prefer
  }

  if (!isAuthenticated) {
    // Store the current path before redirecting
    sessionStorage.setItem("intendedPath", location.pathname);
    return <Navigate to="/signIn" replace />;
  }

  return (
    <div>
      <Component />
    </div>
  );
};

export default ProtectRoute;
